"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGridTradeTPSLOrderId = exports.useGridTradeTPSLParams = void 0;
const react_1 = require("react");
const trade_utils_lib_1 = require("trade_utils_lib");
const interface_1 = require("../../../../interface");
const TPSLUtils_1 = require("./TPSLUtils");
const TradeTPSL_1 = require("./TradeTPSL");
/**
 * 分仓买卖设置止盈止损
 */
function useGridTradeTPSLParams(props) {
    const { topPrice, bottomPrice } = props, tpslProps = __rest(props, ["topPrice", "bottomPrice"]);
    const _a = (0, TradeTPSL_1.useTradeTPSLParams)(tpslProps), { validate: _validate, validateUserInput: _validateUserInput } = _a, 
    // createOrderTPSL: _createOrderTPSL,
    // createOrderTPSLWeb: _createOrderTPSLWeb,
    params = __rest(_a, ["validate", "validateUserInput"]);
    const { orderSide, mode, price } = tpslProps;
    const { triggerPrice } = params;
    const checkError = (0, react_1.useCallback)((tp, side) => {
        const triggerPriceD = new trade_utils_lib_1.SafeDecimal(tp);
        /**
         * 分仓买卖的止盈止损，需要判断触发价格大于0，并且当前价格大于0
         */
        if (triggerPriceD.gt(0) && new trade_utils_lib_1.SafeDecimal(price).gt(0)) {
            if (!topPrice || !bottomPrice) {
                return { code: TPSLUtils_1.TPSLErrorCode.INVALID_TOP_OR_BOTTOM_PRICE };
            }
            const topD = new trade_utils_lib_1.SafeDecimal(topPrice);
            const bottomD = new trade_utils_lib_1.SafeDecimal(bottomPrice);
            // 多仓，止损需低于区间下限价格，止盈需高于区间上限价格
            if (side === interface_1.FuturePositionSide.LONG) {
                if (mode === "sl") {
                    if (triggerPriceD.gte(bottomD)) {
                        return {
                            code: TPSLUtils_1.TPSLErrorCode.LONG_SL_GTE_BOTTOM_PRICE,
                            data: {
                                price: bottomPrice,
                            },
                        };
                    }
                }
                if (mode === "tp") {
                    if (triggerPriceD.lte(topD)) {
                        return {
                            code: TPSLUtils_1.TPSLErrorCode.LONG_TP_LTE_TOP_PRICE,
                            data: {
                                price: topPrice,
                            },
                        };
                    }
                }
            }
            else {
                // 空仓，止损需高于区间上限价格，止盈需低于区间下限价格
                if (mode === "sl") {
                    if (triggerPriceD.lte(topD)) {
                        return {
                            code: TPSLUtils_1.TPSLErrorCode.SHORT_SL_LTE_TOP_PRICE,
                            data: {
                                price: topPrice,
                            },
                        };
                    }
                }
                if (mode === "tp") {
                    if (triggerPriceD.gte(bottomD)) {
                        return {
                            code: TPSLUtils_1.TPSLErrorCode.SHORT_TP_GTE_BOTTOM_PRICE,
                            data: {
                                price: bottomPrice,
                            },
                        };
                    }
                }
            }
        }
        return undefined;
    }, [bottomPrice, mode, price, topPrice]);
    const validate = (0, react_1.useCallback)((estLiqPrice) => {
        const error = checkError(triggerPrice, orderSide === interface_1.CustomOrderSide.BUY ? interface_1.FuturePositionSide.LONG : interface_1.FuturePositionSide.SHORT);
        if (error) {
            return error;
        }
        return _validate(estLiqPrice);
    }, [_validate, checkError, orderSide, triggerPrice]);
    const validateUserInput = (0, react_1.useCallback)((currentTriggerPrice, side, estLiqPrice) => {
        const error = checkError(currentTriggerPrice, side);
        if (error) {
            return error;
        }
        return _validateUserInput(currentTriggerPrice, side, estLiqPrice);
    }, [_validateUserInput, checkError]);
    // const createOrderTPSL: TradeTPSLParams["createOrderTPSL"] = (orderId) => {};
    // const createOrderTPSLWeb: TradeTPSLParams["createOrderTPSLWeb"] = () => {};
    return Object.assign(Object.assign({}, params), { validate,
        validateUserInput });
}
exports.useGridTradeTPSLParams = useGridTradeTPSLParams;
/**
 * 分仓买卖下单成功之后，调用该函数，获取创建`止盈止损`的订单id
 *
 * @description
 * > 分仓买卖止盈止损挂在最容易成交的第一个单上，传close all
 * >
 * > 多仓，挂在区间上限价格单上
 * >
 * > 空仓，挂在区间下限价格单上
 *
 * @param orderSide 当前下单的方向
 * @param orders 下单成功之后的订单列表，需要确保顺序正确，0号位对应最低价格，length-1对应最高价格的订单
 * @returns 设置止盈止损时的订单id
 */
function getGridTradeTPSLOrderId(orderSide, orders) {
    if (!orders.length || orders.length < 2) {
        return;
    }
    if (orderSide === interface_1.CustomOrderSide.BUY) {
        return orders[orders.length - 1].id;
    }
    return orders[0].id;
}
exports.getGridTradeTPSLOrderId = getGridTradeTPSLOrderId;
